import { useMenu } from 'src/contexts/menu-context'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { trackMenuPath } from '../../../utils'
import { Basic } from './Basic'
import { WithLogo } from './WithLogo'

export const LinkItem = ({ item }: ParentAndLinkItemProps) => {
  const { state } = useMenu()

  return (
    <div className="py-2" key={`list-item-${item.label}`}>
      <a
        onClick={() => {
          trackMenuPath(state, item.label)
        }}
        className="text-sm font-semibold tracking-[0.035px] text-[#535353] no-underline"
        href={item.labelURL ? item.labelURL : undefined}
      >
        {item.logoImage ? <WithLogo item={item} /> : <Basic item={item} />}
      </a>
    </div>
  )
}
